// import { getMetaContent } from "./get-meta-content";
var Market = /*#__PURE__*/function (Market) {
  Market["AU"] = "AU";
  Market["NZ"] = "NZ";
  Market["SG"] = "SG";
  return Market;
}(Market || {});
var isSupportedMarket = function isSupportedMarket(code) {
  return code in Market;
};
var getMarketCode = function getMarketCode() {
  var content = process.env.VM_MARKET || "AU";
  return isSupportedMarket(content) ? Market[content] : Market.AU;
};
export { getMarketCode, Market };